'use es6';

import { Map as ImmutableMap } from 'immutable';
import companies from 'reporting-data/dataTypeDefinitions/inboundDb/companies';
import contacts from 'reporting-data/dataTypeDefinitions/inboundDb/contacts';
import conversations from 'reporting-data/dataTypeDefinitions/inboundDb/conversations';
import deals from 'reporting-data/dataTypeDefinitions/inboundDb/deals';
import engagements from 'reporting-data/dataTypeDefinitions/inboundDb/engagements';
import lineItems from 'reporting-data/dataTypeDefinitions/inboundDb/line-items';
import tickets from 'reporting-data/dataTypeDefinitions/inboundDb/tickets';
import * as ObjectTypes from '../../objectTypes';
const DATA_TYPE_DEFINITIONS = {
  [ObjectTypes.CONTACT]: contacts,
  [ObjectTypes.COMPANY]: companies,
  [ObjectTypes.DEAL]: deals,
  [ObjectTypes.ENGAGEMENT]: engagements,
  [ObjectTypes.TICKET]: tickets,
  [ObjectTypes.LINE_ITEM]: lineItems,
  [ObjectTypes.CONVERSATION]: conversations
};
export const MAPPING = ImmutableMap(DATA_TYPE_DEFINITIONS).map(definition => definition ? definition.get('references', ImmutableMap()) : ImmutableMap());